const R = require('ramda');
const { failProofAssign } = require('../utils');
const ArchitectureElement = require('./ArchitectureElement');

/** @type {Keyword} */
class Keyword extends ArchitectureElement {
  constructor(obj) {
    super();
    this.updateData(obj);
  }

  updateData(obj) {
    if (!obj) return;
    obj.channelStatus = obj.status;
    obj.name = obj.text;
    failProofAssign(this, R.omit(['bidCap'], obj));
    this._bidCap = obj.bidCap;
  }

  get level() {
    return 'keyword';
  }

  set subChannels(subChannels) {
    this._subChannels = subChannels;
  }

  get bidCap() {
    return this.bid ?? this.bidAmount ?? this._bidCap;
  }

  get subChannels() {
    if (this.adSet) {
      return this.adSet.subChannels;
    }
    if (this._subChannels) return this._subChannels;
    return [this.channel];
  }
}

module.exports = Keyword;
